<template>
  <div class="uk-flex uk-flex-center" uk-grid>

    <div class="uk-width-1-1">
      <h2 class="uk-text-center uk-margin-large-top" v-if="!userHasCard">Choose a Payment Option</h2>
      <h2 class="uk-text-center uk-margin-large-top" v-else>Your Payment Options</h2>
    </div>

    <div class="uk-width-1-1 uk-margin-large-bottom">
      <div class="uk-grid-match uk-flex uk-flex-center uk-margin-large-top" uk-grid>

        <div class="uk-width-1-3@xl uk-width-1-2@l uk-width-1-1@s" v-if="!userHasCard">
          <router-link :to="{ name: 'CreateCreditCard' }">
            <Card class="ba-payment-method-card uk-card-hover uk-border-rounded uk-box-shadow-small">
              <template v-slot:body>
                <div uk-grid>
                  <div class="uk-width-1-1 uk-text-center uk-margin-medium-bottom">
                    <h4>Add Credit Card</h4>
                  </div>
                  <div class="uk-width-1-1 uk-margin-small-top uk-flex uk-flex-center">
                    <BACreditCard></BACreditCard>
                  </div>
                  <div class="uk-width-1-1 uk-text-center">
                    <p class="uk-text-meta">This card will be automatically charged for any services you create after all of your account credit is depleted.</p>
                  </div>
                </div>
              </template>
            </Card>
          </router-link>
        </div>

        <div class="uk-width-1-3@xl uk-width-1-2@l uk-width-1-1@s" v-else>
          <router-link :to="{ name: 'ViewCreditCard' }">
            <Card class="ba-payment-method-card uk-card-hover uk-border-rounded uk-box-shadow-small" :class="{ 'ba-payment-error': errorChargingCard || is_card_expired }">
              <template v-slot:body>
                <div uk-grid>
                  <div class="uk-width-1-1 uk-text-center uk-margin-medium-bottom">
                    <h4>Your Card</h4>
                  </div>
                  <div class="uk-width-1-1 uk-margin-small-top uk-flex uk-flex-center">
                    <BACreditCard :cardholder="cardholder" :last4="credit_card.last4" :expiration="expiration_display_format" :type="get_type"></BACreditCard>
                  </div>
                  <div class="uk-width-1-1 uk-text-center">
                    <p class="uk-text-meta ba-payment-error-text" v-if="is_card_expired">Your card has expired. Please update your payment method.</p>
                    <p class="uk-text-meta ba-payment-error-text" v-if="errorChargingCard">There was an error charging your card. Please review your card details.</p>
                    <p class="uk-text-meta" v-if="!is_card_expired && !errorChargingCard">This card will be automatically charged for any services you create after all of your account credit is depleted.</p>
                  </div>
                </div>
              </template>
            </Card>
          </router-link>
        </div>

        <div class="uk-width-auto@xl uk-width-1-1@m uk-width-auto@s">
          <div class="uk-flex ba-center-or-icon">
            <span uk-icon="icon: chevron-left; ratio: 2.5"></span>
            <h2 class="uk-flex-middle uk-margin-remove">or</h2>
            <span uk-icon="icon: chevron-right; ratio: 2.5"></span>
          </div>
        </div>

        <div class="uk-width-1-3@xl uk-width-1-2@l uk-width-1-1@s">
          <router-link :to="{ name: 'AccountCredit' }">
            <Card class="ba-payment-method-card uk-card-hover uk-border-rounded uk-box-shadow-small">
              <template v-slot:body>
                <div class="uk-flex-center" uk-grid>
                  <div class="uk-width-1-1 uk-text-center uk-margin-small-bottom">
                    <h4>Add Account Credit</h4>
                  </div>
                  <div class="uk-width-1-1 uk-margin-top-remove uk-flex uk-flex-center">
                    <img class="uk-preserve" src="@/assets/images/paypal-colored-icon.svg" width="325" height="200" uk-svg />
                  </div>
                  <div class="uk-width-1-1 uk-text-center">
                    <p class="uk-text-meta">Manually add credit to your account. Services will charge your account credit until it is depleted.</p>
                  </div>
                </div>
              </template>
            </Card>
          </router-link>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import Card from '@/components/common/card.vue';
import BACreditCard from '@/components/portal/creditcard.vue';

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: 'PaymentOptions',
  components: {
    Card,
    BACreditCard
  },
  data() {
    return {
      type: 'mastercard',
      errorChargingCard: false
    }
  },
  computed: {
    ...mapGetters('creditcard', ['cardholder', 'expiration_display_format', 'expiration_year', 'expiration_month', 'is_card_expired', 'get_type']),
    ...mapState('creditcard', ['credit_card']),
    userHasCard() {
      return this.credit_card ? true : false
    }
  },
  created() {
    this.GET_CREDIT_CARD();
  },
  methods: {
    ...mapActions('creditcard', ['GET_CREDIT_CARD']),
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/less/theme.less";

a {
  &:hover {
    text-decoration: none;
  }
}
.ba-center-or-icon {
  justify-content: center;
  align-items: center;

  h2 {
    color: #666;
    text-transform: uppercase;
  }
}
.ba-payment-method-card {
  border: 1px solid rgba(0,0,0,0.1);
  padding: 15px;
  cursor: pointer;
  min-width: 450px;

  &:hover {
    background-color: #fff;
    border: 1px solid rgba(@ba-gold, 0.5);
  }
}
.ba-payment-error {
  border: 1px solid rgba(@ba-red, 0.5);

  &:hover {
    border: 1px solid rgba(@ba-red, 1);
  }
}
.ba-payment-error-text {
  color: rgba(@ba-red, 1);
}
</style>
